/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-22 16:16:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-24 10:16:04
 * @FilePath: \mrc-base-server-view\src\mixin\national.js
 */
export default {
  data () {
    return {
      advanceList: []
    }
  },

  methods: {
    showAdvanceLabel (obj) {
      const view_fields = obj.view_fields || 'view_fields'
      const value_field = obj.value_field || 'value_field'
      const value = obj.value || ''

      const index = this.advanceList.findIndex(item => item[value_field] == value)
      if (index > -1) {
        return this.INT(this.advanceList[index][view_fields])
      }
      return ''
    }
  },

}